import styled from "styled-components";

export const EventsList = styled.ol`
  && {
    margin: 0;
  }
`;
